import React from 'react'
// themes
import { colors } from 'themes/index'
import { SearchIconWrapper } from 'themes/views/layouts'
// components
import { ReduxInput } from 'components/FormElements'
import { SearchRoundedIcon } from 'components/UI/PageSearch/views'
// views
import { ArrowIcon, FieldsWrapper, FieldWrapper, IconWrapper, SearchWrapper } from './views'
// types
import { IField } from 'types/graphql'
import { FilterField } from '../../index'

interface Props {
  fields: IField[]
  filter: FilterField[]
  setField: (field: IField) => void
  setIsConfigured: (value: boolean) => void
}

const Fields: React.FC<Props> = ({ fields, filter, setField, setIsConfigured }) => {
  return (
    <>
      {!!filter.length && (
        <IconWrapper>
          <ArrowIcon htmlColor={colors.purple500} onClick={() => setIsConfigured(false)} />
        </IconWrapper>
      )}
      <form>
        <SearchWrapper>
          <SearchIconWrapper>
            <SearchRoundedIcon htmlColor={colors.gray380} />
          </SearchIconWrapper>
          <ReduxInput withEllipsis name='search' disableUnderline placeholder='Search...' />
        </SearchWrapper>
      </form>
      <FieldsWrapper>
        {fields.map((field) => (
          <FieldWrapper
            key={field.id}
            data-testid='risk-filter-field-option'
            data-entity-id={field.id}
            onClick={() => setField(field)}>
            {field.label}
          </FieldWrapper>
        ))}
      </FieldsWrapper>
    </>
  )
}

export default Fields
